// Deskon: drives the thin progress bar of the mobile product media gallery.
// The bar markup lives in snippets/slideshow.liquid; it is only visible inside <media-gallery> on mobile.
const SCROLLER = 'media-gallery slideshow-slides';
let frame = 0;

function update(scroller) {
  const container = scroller.closest('slideshow-container');
  const bar = container && container.querySelector(':scope > .deskon-gallery-progress');
  if (!bar) return;
  const thumb = bar.firstElementChild;
  const slides = Array.from(scroller.children).filter((slide) => slide.offsetWidth > 0);
  const count = slides.length;
  if (count < 2) {
    bar.hidden = true;
    return;
  }
  bar.hidden = false;
  const max = scroller.scrollWidth - scroller.clientWidth;
  const progress = max > 0 ? Math.min(1, Math.max(0, Math.abs(scroller.scrollLeft) / max)) : 0;
  thumb.style.width = `${100 / count}%`;
  thumb.style.transform = `translateX(${progress * (count - 1) * 100}%)`;
}

function updateAll() {
  document.querySelectorAll(SCROLLER).forEach(update);
}

function schedule(target) {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => (target ? update(target) : updateAll()));
}

if (!window.deskonGalleryProgress) {
  window.deskonGalleryProgress = true;
  document.addEventListener(
    'scroll',
    (event) => {
      const target = event.target;
      if (target instanceof Element && target.matches(SCROLLER)) schedule(target);
    },
    { capture: true, passive: true }
  );
  window.addEventListener('resize', () => schedule(), { passive: true });
  // The gallery is re-rendered when the customer changes variant.
  new MutationObserver(() => schedule()).observe(document.body, { childList: true, subtree: true });
  updateAll();
}
